import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoDespesasMensais: ['administracao'],
    removePredioDespesasMensais: ['predio'],
    removeUnidadeDespesasMensais: ['unidade'],
    removeTipoServicoDespesasMensais: ['tipoServico'],
    removeCnpjDespesasMensais: ['cnpj'],
    removeIdentificadorDespesasMensais: ['identificador'],
    removeNomeFornecedorDespesasMensais: ['nomeFornecedor'],
    setMostraAplicarFiltroDespesasMensais: [],
    limpaFiltroDespesasMensais: [],
    aplicarFiltroDespesasMensais: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    competencia: [],
    administracao: [],
    predio: [],
    unidade: [],
    tipoServico: [],
    cnpj: '',
    identificador: '',
    nomeFornecedor: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removePredio = (state = INITIAL_STATE, action) => {
    state.predio.splice(state.predio.indexOf(action.predio), 1)
    state.predio = Array.from(state.predio)
    return { ...state, mostraAplicarFiltro: true }
}

const removeUnidade = (state = INITIAL_STATE, action) => {
    state.unidade.splice(state.unidade.indexOf(action.unidade), 1)
    state.unidade = Array.from(state.unidade)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoServico = (state = INITIAL_STATE, action) => {
    state.tipoServico.splice(state.tipoServico.indexOf(action.tipoServico), 1)
    state.tipoServico = Array.from(state.tipoServico)
    return { ...state, mostraAplicarFiltro: true }
}

const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}

const removeIdentificador = (state = INITIAL_STATE, action) => {
    return { ...state, identificador: '', mostraAplicarFiltro: true }
}

const removeNomeFornecedor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeFornecedor: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_DESPESAS_MENSAIS]: removeAdministracao,
    [Types.REMOVE_PREDIO_DESPESAS_MENSAIS]: removePredio,
    [Types.REMOVE_UNIDADE_DESPESAS_MENSAIS]: removeUnidade,
    [Types.REMOVE_TIPO_SERVICO_DESPESAS_MENSAIS]: removeTipoServico,
    [Types.REMOVE_CNPJ_DESPESAS_MENSAIS]: removeCnpj,
    [Types.REMOVE_IDENTIFICADOR_DESPESAS_MENSAIS]: removeIdentificador,
    [Types.REMOVE_NOME_FORNECEDOR_DESPESAS_MENSAIS]: removeNomeFornecedor,
    [Types.SET_MOSTRA_APLICAR_FILTRO_DESPESAS_MENSAIS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_DESPESAS_MENSAIS]: limpaFiltro,
    [Types.APLICAR_FILTRO_DESPESAS_MENSAIS]: aplicarFiltro,
})
